import { render } from "./kebijakanKeamananInformasi.vue?vue&type=template&id=7d7708aa"
import script from "./kebijakanKeamananInformasi.vue?vue&type=script&lang=js"
export * from "./kebijakanKeamananInformasi.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__